import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useUserInviteAccept } from "../hooks/useUser";
import { Button, Flex, Transition } from "@mantine/core";
import { useAuth0 } from "@auth0/auth0-react";
import ImageMessage from "components/ui/Layout/ImageMessage";
import { TransitionDefault } from "mantineTheme";
import Cookies from "js-cookie";

const Accept = () => {
  const isLoggedIn = !!Cookies.get("aId") && !!Cookies.get("access_token") && !!Cookies.get("email")
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const invite = queryParams.get("invite");

  const { data, isSuccess, isError, refetch } = useUserInviteAccept(invite);
  const { loginWithRedirect, logout } = useAuth0();

  const handleAuth = (type) => {
    loginWithRedirect({
      authorizationParams: {
        screen_hint: type || (data?.isNewUser ? 'signup' : 'login'),
        redirect_uri: window.location.origin + '/home',
        login_hint: data?.email || null
      },
    });
  };

  useEffect(() => {
    if (invite && !isLoggedIn) {
      refetch({
        invitationId: invite,
      });
    }
  }, [invite]);

  useEffect(() => {
    if ((isError || isSuccess) && !isLoggedIn) {
      handleAuth();
    }
  }, [isError, isSuccess]);

  return (
    <>
      {isLoggedIn ?
        <>
          <Transition
            {...TransitionDefault}
            mounted={true}
          >
            {(style) => (
              <Flex style={style}>
                <ImageMessage
                  title="We are unable to process the invite."
                  description={
                    <>
                      <div>
                        We have detected that you are logged in with the email <b>{Cookies.get("email")}</b>.
                        You will not be able to accept an invite for a different email while logged in.
                        Please logout of existing sessions or copy the invite link to an incognito window in order to accept the invite on behalf of a different user.
                      </div>
                      <Flex gap="sm">
                        <Button
                          className="w-auto"
                          size="lg"
                          my="lg"
                          onClick={() => logout({
                            logoutParams: {
                              returnTo: `${window.location.origin}/auto-logout`,
                            },
                          })}
                          color="red"
                        >
                          Logout Now
                        </Button>
                        <Button
                          component="a"
                          size="lg"
                          my="lg"
                          href={window.env.REACT_APP_URL_MY_SITE}
                          className="w-auto"
                          variant="default"
                        >
                          Return to DNA Portal
                        </Button>
                      </Flex>
                    </>
                  }
                />
              </Flex>
            )}
          </Transition>
        </> : <>
          <Transition {...TransitionDefault} mounted={!isSuccess && !isError}>
            {(style) => (
              <Flex style={style}>
                <ImageMessage title="Validating invite..." />
              </Flex>
            )}
          </Transition>
        </>}
    </>
  );
};

export default Accept;